import(/* webpackMode: "eager", webpackExports: ["ReferralsWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
